module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-latin-ext609.450563d.woff2";